// extracted by mini-css-extract-plugin
export default {"layer":"Hero_layer__CJksR","btn1":"Hero_btn1__dYocm","btn2":"Hero_btn2__ilNsU","color":"Hero_color__967Ug","pad":"Hero_pad__ybA4l","customsWidth":"Hero_customsWidth__+pH0B"};